import { Label } from '@/components/ListView/Label';
import { useTranslation } from '@/i18n';
import { Bottom, ListView, Top } from '@moneyforward/ap-frontend-components';
import { FC, memo } from 'react';

export type DetailTopViewProps = {
  label: string;
  visibility: boolean;
  tooltip_message: string;
};

const leftRightRatio = {
  left: {
    max: '160px',
    min: '160px',
  },
  right: {},
};

export const DetailTopView: FC<DetailTopViewProps> = memo(
  ({ label, visibility, tooltip_message }) => {
    const { t } = useTranslation();
    return (
      <ListView leftRightRatio={leftRightRatio}>
        <Top>
          <Label>{t('transaction_items.table.label')}</Label>
          <div>{label}</div>
        </Top>
        <Top>
          <Label> {t('transaction_items.table.tooltip_message')}</Label>
          <div>{tooltip_message}</div>
        </Top>
        <Bottom>
          <Label>{t('transaction_items.table.is_visible')}</Label>
          <div>
            {visibility
              ? t('transaction_items.table.visible')
              : t('transaction_items.table.invisible')}
          </div>
        </Bottom>
      </ListView>
    );
  }
);
DetailTopView.displayName = 'DetailTopView';
